/*
 * @Copyright: Copyright (c) Pray LLC. All rights reserved.
 * @Author: Raguvind Tharanitharan
 * @Date: 2022-09-12 10:18:12
 * @Last Modified by: Raguvind Tharanitharan
 * @Last Modified time: 2022-09-12 22:12:00
*/
import React, { useEffect, useState } from 'react';
import withRouter from '../with-router';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Grid } from '@mui/material';
import AppNavigationBar from './components/vw-app-navigation-bar';
import Sidebar from './components/vw-sidebar';
import { Loader } from '../common';
import { loadSettings, updateSetting } from './stores/settings';
import ReportView from './components/vw-report';
import PreviewView from './components/vs-preview';

export default withRouter(function HomeDefaultView(props) {
  const user = useSelector((state) => state.user);
  const [loaded, setloaded] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // Validating if the user is already populated or not.
    // If the user is loaded then navigated to dashboard.
    if (user == null) {
      navigate('/');
    }

    if (loaded === false) {
      dispatch(loadSettings())
        .unwrap()
        .then(data => {
          navigate(data.features[0].links[0].link);
          return refreshView(data);
        });
    }
  });

  const refreshView = (data) => {
    setloaded(true);
    dispatch(updateSetting(data));
  };

  // Render components of the login screen.
  return <>
    <Box sx={{ display: 'flex' }}>
      {!loaded && <Loader />}
      {loaded &&
        <>
          <AppNavigationBar />
          <Sidebar />
          <Grid sx={{ height: '100vh', px: 0, flex: 1 }}>
            <Routes>
              <Route exact path="/preview-listen" element={
                <PreviewView
                  imageUrl="https://mir-s3-cdn-cf.behance.net/project_modules/2800_opt_1/3e454a117508598.61a96fb2dcc59.jpg"
                  header="Listen Analytics"
                  content="Stay organized and in control with our audio content library, a centralized hub for monitoring your content creation and distribution. Gain insights, track performance, and optimize your content strategy in one place."
                  buttonText="Unlock Power Of Pray Analytics" />
              } />
              <Route exact path="/preview-watch" element={
                <PreviewView
                  imageUrl="https://mir-s3-cdn-cf.behance.net/project_modules/2800_opt_1/21c916117508598.62c6f31c87e4b.jpg"
                  header="Watch Analytics"
                  content="A powerful tool that provides analytics and visualizations to track your video libraries' performance, engagement, and audience behavior. Gain actionable insights to optimize your video strategy and drive meaningful results."
                  buttonText="Unlock Power Of Pray Analytics" />
              } />
              {/* All default routes are routed to the report view */}
              <Route exact path="/*" element={<ReportView />} />
            </Routes>
          </Grid>
        </>}
    </Box>
  </>;
});